import { Card, Col, Divider, Form, Input, Button, Row, Select, message, Checkbox } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import ConsultHeaderCard from "../../../../components/Common/Cards/ConsultHeaderCard";
import { filterOption, isValidValue, setFormFieldValue } from "../../../../helpers/FormHelper";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";
import { useSelector } from "react-redux";
import DiasporaReferenceService from "../../../../services/Diaspora/DiasporaReferenceService";
import { capitalizeFirstLetter } from "../../../../helpers/StringFormatter";
import { getFullName } from "../../../../helpers/ObjectHelper";
import moment from "moment";
import ErrorAlertModal from "../../../../components/Common/Modals/ErrorAlertModal";



const rules = {
    voter: [
        {
            required: false,
            message: "Ju lutem zgjidhni votuesin!",
        },
    ],
    country: [
        {
            required: true,
            message: "Ju lutem zgjidhni shtetin!",
        },
    ],
    referenceType: [
        {
            required: true,
            message: "Ju lutem zgjidhni tipin e referencës!",
        },
    ],
    city: [
        {
            required: false,
            message: "Ju lutem plotësoni qytetin!",
        },
    ],
    zip: [
        {
            required: false,
            message: "Ju lutem plotësoni kodin postar!",
        },
    ],
    phone: [
        {
            required: true,
            message: "Ju lutem plotësoni numrin e telefonit!",
        },
    ],
    name: [
        {
            required: true,
            message: "Ju lutem plotësoni emrin",
        },
    ],
    surname: [
        {
            required: false,
            message: "Ju lutem plotësoni mbiemrin",
        },
    ]
};


const initialChecks = {
    hasReferues: false,
};



const Edit = ({ item, countries, referenceTypes, onBack, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [checks, setChecks] = useState(initialChecks);
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorModal, setErrorModal] = useState(false);
    const [selectedReferenceTypeCode, setSelectedReferenceTypeCode] = useState(item?.reference_type?.code);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            name: getFullName(item?.voter),
            surname: setFormFieldValue(item?.voter?.surname),
            father_name: setFormFieldValue(item?.voter?.father_name),
            birthdate: isValidValue(item?.voter?.dob) ? moment(item?.voter?.dob).format("DD-MM-YYYY") : null,
            region: setFormFieldValue(item?.voter?.region?.name),
            municipality: setFormFieldValue(item?.voter?.municipality?.name),
            unit: setFormFieldValue(item?.voter?.unit?.name),
            phone: setFormFieldValue(item?.emigrant_phone),
            country: setFormFieldValue(item?.country?.id),
            city: setFormFieldValue(item?.emigrant_city),
            zip_code: setFormFieldValue(item?.zip_code),
            note: setFormFieldValue(item?.note),
            referenceType: setFormFieldValue(item?.reference_type?.code),
            referuesName: setFormFieldValue(item?.referues_name),
            referuesSurname: setFormFieldValue(item?.referues_surname),
            referuesPhone: setFormFieldValue(item?.referues_phone),
        });
        setSelectedReferenceTypeCode(item?.reference_type?.code);
        setChecks({ hasReferues: item?.has_referues ?? false })
    }, [form, item]);


    const formatRequestData = (data) => {
        return {
            voter_id: setFormFieldValue(item?.voter?.id),
            country_id: setFormFieldValue(data?.country),
            emigrant_city: capitalizeFirstLetter(data?.city),
            emigrant_phone: setFormFieldValue(data?.phone),
            zip_code: setFormFieldValue(data?.zip_code),
            note: capitalizeFirstLetter(data?.note),
            has_referues: checks.hasReferues,
            reference_type: setFormFieldValue(data?.referenceType),
            referues_name: capitalizeFirstLetter(data?.referuesName),
            referues_surname: capitalizeFirstLetter(data?.referuesSurname),
            referues_phone: setFormFieldValue(data?.referuesPhone),
        };
    };


    const onUpdate = async () => {
        try {
            setSubmitLoading(true);
            const data = await form.validateFields();
            const requestData = formatRequestData(data);
            const referenceId = setFormFieldValue(item?.id);
            const response = await DiasporaReferenceService.updateData(token, requestData, referenceId);
            const responseData = response.data;
            if (responseData) {
                await message.success('Referenca u modifikua me sukses!', 1);
                setErrorMessage(null);
                onSuccess();
            } else {
                const errorMessage = 'Një gabim ndodhi gjatë modifikimit të referencës!';
                setErrorMessage(errorMessage);
                setErrorModal(true);
            }
        } catch (error) {
            if (error?.values) {
                setSubmitLoading(false);
                return;
            }
            const errorMessage = getErrorMessage(error);
            setErrorMessage(errorMessage);
            setErrorModal(true);
        } finally {
            setSubmitLoading(false);
        }
    };


    const onCheckboxChange = (event, checkType) => {
        const isChecked = event.target.checked;
        setChecks({ ...checks, [checkType]: isChecked });
    };


    const onReferenceTypeChange = (value) => {
        const selectedReferenceTypeCode = setFormFieldValue(value);
        setSelectedReferenceTypeCode(selectedReferenceTypeCode);
        const hasReferuesSelected = selectedReferenceTypeCode === "biznesi" ? true : checks.hasReferues;
        setChecks({
            ...checks,
            hasReferues: hasReferuesSelected,
        });
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24} className="mb-3">
                    <Col span={24}>
                        <ConsultHeaderCard
                            longTitle="Jeni duke modifikuar referencën e diasporës"
                            shortTitle="Refrencë diaspore"
                            onBack={onBack}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ borderRadius: "0" }}>
                            <Form form={form} labelAlign="left" labelCol={{ span: 8 }} layout="horizontal">
                                <Row gutter={24}>
                                    <Col span={24}>
                                        {/* VOTER */}
                                        <Row gutter={24}>
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhënat e votuesit
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} align="top" className="m-0">
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="name" label="Emri" rules={rules.voter}>
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="father_name" label="Atësia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="birthdate" label="Datëlindja">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={4} lg={4} md={24} sm={24} xs={24} />
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="region" label="Qarku">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="municipality" label="Bashkia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="unit" label="Nj. administrative">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/* EMIGRANT */}
                                        <Row gutter={24} className="mt-4">
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhëna shtesë
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} className="m-0">
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="phone" label="Telefoni" rules={rules.phone}>
                                                            <Input type="text" placeholder="Telefoni..." />
                                                        </Form.Item>
                                                        <Form.Item name="country" label="Shteti i emigrimit" rules={rules.country}>
                                                            <Select
                                                                showSearch
                                                                optionLabelProp="children"
                                                                filterOption={filterOption}
                                                                placeholder="-Zgjidhni shtetin-"
                                                            >
                                                                {countries?.map((item) => (
                                                                    <Select.Option key={item?.id} value={item?.id}>
                                                                        {item?.country_name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item name="city" label="Qyteti i emigrimit" rules={rules.city}>
                                                            <Input type="text" placeholder="Qyteti..." />
                                                        </Form.Item>
                                                        <Form.Item name="zip_code" label="Kodi postar" rules={rules.zip}>
                                                            <Input type="text" placeholder="ZIP..." />
                                                        </Form.Item>
                                                        <Form.Item name="note" label="Shënime">
                                                            <Input.TextArea rows={2} type="text" placeholder="Shënime..." />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={4} lg={4} md={24} sm={24} xs={24} />
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Row gutter={24}>
                                                            <Col span={24}>
                                                                <Form.Item name="referenceType" label="Tipi i referencës" rules={rules.referenceType}>
                                                                    <Select
                                                                        showSearch
                                                                        optionLabelProp="children"
                                                                        filterOption={filterOption}
                                                                        onChange={onReferenceTypeChange}
                                                                        placeholder="-Zgjidhni opsionin-"
                                                                    >
                                                                        {referenceTypes?.map((item) => (
                                                                            <Select.Option key={item?.id} value={item?.id}>
                                                                                {item?.name}
                                                                            </Select.Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                                <Form.Item name="hasReferues" label="Ka referues">
                                                                    <Checkbox
                                                                        checked={checks.hasReferues}
                                                                        onChange={(event) => onCheckboxChange(event, 'hasReferues')}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>

                                                        {checks.hasReferues === true && (
                                                            <Row gutter={24}>
                                                                <Col span={24}>
                                                                    <Form.Item name="referuesName" label="Emri i referuesit" rules={rules.name}>
                                                                        <Input type="text" placeholder="Emri..." />
                                                                    </Form.Item>
                                                                    <Form.Item name="referuesSurname" label="Mbiemri i referuesit" rules={selectedReferenceTypeCode === "biznesi" ? null : rules.surname}>
                                                                        <Input type="text" placeholder="Mbiemri..." />
                                                                    </Form.Item>
                                                                    <Form.Item name="referuesPhone" label="Telefoni i referuesit">
                                                                        <Input type="text" placeholder="Telefoni..." />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        )}

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100" />
                                    </Col>
                                </Row>
                                <Row gutter={24} className="p-2">
                                    <Col xl={8} lg={8} md={4} sm={0} xs={0} />
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            type="primary"
                                            loading={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CheckOutlined />}
                                            onClick={onUpdate}
                                        >
                                            Ruaj
                                        </Button>
                                    </Col>
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            danger
                                            disabled={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CloseOutlined />}
                                            onClick={onBack}
                                        >
                                            Mbyll
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <ErrorAlertModal
                            isOpen={errorModal}
                            title={errorMessage}
                            subtitle="Modifiko referencën e diasporës"
                            onClose={() => setErrorModal(false)}
                            onConfirm={() => setErrorModal(false)}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default Edit;